import React from 'react'
import HistoryInterface from '../interfaces/HistoryInterface'

type ContextProps = HistoryInterface

const HistoryContext = React.createContext<ContextProps>({} as HistoryInterface)

export default HistoryContext
